import { NgModule }      from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RichTextAreaFieldWithVariablesComponent } from './rich-textarea-field-with-variables.component';
import { RichTextareaFieldModule } from '../rich-textarea-field/rich-textarea-field.module';
import { VariablesHelpModule } from 'libraries/component/variablesHelp/variablesHelp.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RichTextareaFieldModule,
    VariablesHelpModule,
  ],
  declarations: [
    RichTextAreaFieldWithVariablesComponent,
  ],
  exports: [
    RichTextAreaFieldWithVariablesComponent,
  ]
})
export class RichTextareaFieldWithVariablesModule {  }